import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";
import Slider from "react-slick";

export const PaddingContainer = styling(Grid)((props) => ({
  paddingBottom: "60px",
}));

export const GridStyled = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  width: "100%",
  height: "100%",
  maxWidth: "1440px",
  padding: "0 100px 160px 100px",
  margin: "auto",
  paddingTop: "100px",
  overflow: "hidden",

  [props.theme.breakpoints.down("lg")]: {
    padding: "48px 16px 16px 16px",
    alignSelf: "stretch",
  },

  [props.theme.breakpoints.down("tablet")]: {
    // maxHeight: "724px",
  },
}));

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  alignSelf: "stretch",
  flexDirection: "column",
  margin: "auto",
  gap: "24px",
  height: "100%",
  width: "100%",
  position: "relative",

  [props.theme.breakpoints.down("lg")]: {
    padding: "0px",
    gap: "16px",
    paddingBottom: "60px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    // maxHeight: "768px",
    // padding: "56px 24px",
    padding: "0px",
    gap: "24px",
  },
}));

export const GridTagline = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: "56px",
  width: "100%",
  maxWidth: "unset",
  // position: props?.mobile && "sticky",
  // top: props?.mobile && "60px",
  backgroundColor: "white",
  padding: "16px 0px",

  [props.theme.breakpoints.down("tablet")]: {
    padding: "56px 24px 0px 24px",
    position: "relative",
    maxWidth: "736px",
  },
}));

export const TaglineContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "24px",
  alignSelf: "stretch",

  [props.theme.breakpoints.down("lg")]: {
    gap: "8px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "315px",
    margin: "auto",
  },
}));

export const TaglineSubContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
}));

export const TaglineOverline = styling(Typography)((props) => ({
  color: "#512ACC",
  fontFamily: "Manrope",
  fontSize: "18px",
  fontWeight: "600",
  lineHeight: "21.6px",
  letterSpacing: "0.27px",
  alignSelf: "stretch",
  textAlign: "center",
  textTransform: "uppercase",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "14px",
    lineHeight: "16.8px",
    letterSpacing: "0.21px",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "48px",
  fontWeight: "400",
  lineHeight: "57.6px",
  fontFamily: "Georgia",
  textAlign: "center",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "32px",
    lineHeight: "38.4px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
  },
}));

export const TaglineSubtitle = styling(Typography)((props) => ({
  color: "rgba(0, 0, 0, 0.87)",
  fontFamily: "Inter",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "21.6px",
  textAlign: "center",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "19.2px",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardSection = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "24px",
  alignSelf: "stretch",
  maxWidth: "1440px",
  width: "100%",
  // overflow: "scroll",

  [props.theme.breakpoints.down("lg")]: {
    gap: "16px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  height: "100%",
  minHeight: "440px",
  maxWidth: "330px",
  gap: "24px",
  flex: "1 0 0",
  padding: "24px",
  borderRadius: "8px",
  border: "1px solid rgba(0, 0, 0, 0.16)",
  background: "#EFEFFD",

  [props.theme.breakpoints.down("1024")]: {
    padding: "16px 16px 48px 16px",
    gap: "16px",
    minHeight: "350px",
    minWidth: "360px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    flexDirection: "column",
    padding: "20px 20px 48px 20px",
    minWidth: "unset",
    minHeight: "430px",
    gap: "16px",
    flex: "0 0 100%",
    maxWidth: "88vw",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  flexShrink: "0",
  borderRadius: "8px",
  minHeight: "227px",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {
    maxHeight: "185px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "185px",
    maxWidth: "100%",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  alignSelf: "stretch",
  gap: "16px",

  [props.theme.breakpoints.down("lg")]: {
    gap: "8px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    textAlign: "center",
  },
}));

export const MobileCardSlider = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  maxHeight: "unset",
  overflow: "auto",
  gap: "16px",
  scrollbarWidth: "none", // For Firefox
  msOverflowStyle: "none", // For Internet Explorer and Edge
  "&::-webkit-scrollbar": {
    display: "none", // For Chrome, Safari, and Opera
  },
}));

export const CardText = styling(Typography)((props) => ({
  color: props.type == "desc" ? "rgba(0, 0, 0, 0.60)" : "rgba(0, 0, 0, 0.87)",
  fontFamily: props.type == "desc" ? "Inter" : "Manrope",
  fontSize: props.type == "desc" ? "18px" : "24px",
  fontStyle: "normal",
  fontWeight: props.type == "desc" ? 400 : 600,
  lineHeight: props.type == "desc" ? "23.4px" : "28.8px",
  alignSelf: "stretch",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: props.type == "desc" ? "14px" : "18px",
    fontWeight: props.type == "desc" ? 400 : 600,
    lineHeight: props.type == "desc" ? "18.2px" : "21.6px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "14px" : "16px",
    lineHeight: props.type == "desc" ? "21px" : "22.4px",
  },
}));

export const SliderStyled = styling(Slider)((props) => ({
  width: "100%",
  // overflow: "hidden",

  [props.theme.breakpoints.down("1024")]: {
    "& .slick-slide": {
      paddingLeft: "16px",
    },

    "& .slick-dots": {
      bottom: "-35px",
    },
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "0px 8px",
    "& .slick-slide": {
      padding: "0px 8px",
    },
  },
}));

export const CarouselContainer = styling(Grid)((props) => ({
  position: "relative",
  width: "100%",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));

export const CardsWrapper = styling("div")((props) => ({
  display: "flex",
  transition: "transform 0.5s ease-in-out",
  gap: "8px",
  padding: "0 24px",
}));

export const NavigationButtons = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  top: "-50px",
  gap: "16px",
  width: "100%",
}));

export const StepButton = styling(Button)((props) => ({
  display: "flex",
  width: "48px",
  height: "48px",
  minWidth: "48px",
  padding: "10px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  borderRadius: "24px",
  background: props?.disabled ? "#D4D0EE" : "#40249B",
  color: "#fff",
  boxShadow: "0px 1px 3px 1px rgba(0, 0, 0, 0.25)",
  cursor: props?.disabled ? "not-allowed" : "pointer",
  ":hover": {
    backgroundColor: props?.disabled ? "#D4D0EE" : "#40249B",
  },
}));
